__turbopack_context__.v({
  "profile": "Avatar-module__MjXZNq__profile",
  "root": "Avatar-module__MjXZNq__root",
});
